import axios from "axios";
// Falls back to localhost for local dev (`npm start`); in production these
// must be set at build time via REACT_APP_* env vars (baked into the bundle -
// CRA cannot read them at runtime) to the server's real public address,
// since "localhost" from the browser's own perspective is the visitor's
// machine, not wherever this app is actually deployed.
const BASE_URL_PROTUCT = process.env.REACT_APP_ITEMS_API_URL || "http://localhost:8080/api/items";
const BASE_URL = process.env.REACT_APP_USERS_API_URL || "http://localhost:8081";


// users
const setAuthHeader = (token) => {
   
    localStorage.setItem("token", token);
    
}
const removeAuthHeader = () => {
    localStorage.removeItem("token");
}

const getAuthHeader = () => {
    const token = localStorage.getItem("token");

    
    return {    
            Authorization: `Bearer ${token}`
        };
    
}
export const logout = () => {
 removeAuthHeader();   
}
export const register = async (user) => {
    try {
    const {data} = await axios.post(`${BASE_URL}/users/register`, user);
    const token = data.jwt;
    setAuthHeader(token);
    return data;
    } catch (error) {
        throw error;
    }
}
export const loging = async(Credentials) => {

    const {data} = await axios.post(`${BASE_URL}/authenticate`, Credentials);
    const token = data.jwt;

    setAuthHeader(token);

    return data;
}
export const loginWithGoogle = async (idToken) => {
    const { data } = await axios.post(`${BASE_URL}/authenticate/google`, { idToken });
    setAuthHeader(data.jwt);
    return data;
}
// Both intentionally unauthenticated - no token exists yet at this point in
// the flow. forgot-password always resolves the same way regardless of
// whether the email exists - see UserController's no-leak contract.
export const requestPasswordReset = (email) => {
    return axios.post(`${BASE_URL}/users/forgot-password`, { email });
}
export const resetPassword = (token, newPassword) => {
    return axios.post(`${BASE_URL}/users/reset-password`, { token, newPassword });
}


export const updateCurrentUser = (updatedCurrentUser) => {
    return axios.put(`${BASE_URL}/users`, updatedCurrentUser, { headers: getAuthHeader() });
}
export  const deltedUser = (email) => {
    return axios.delete(`${BASE_URL}/admin/delete-user/${email}`, { headers: getAuthHeader() });
}
export const fetchCurrentUser = () => {
    return axios.get(`${BASE_URL}/users`, { headers: getAuthHeader() });
}
export const fetchAllUsers = (page) => {
    return axios.get(`${BASE_URL}/admin/all-users/?page=${page}&size=5`, { headers: getAuthHeader() });
}

// items

export const getAllItems =  (page ) => {
    return axios.get(`${BASE_URL}/admin/all_items/?page=${page}&size=20`, { headers: getAuthHeader() });
}
export const getAllChocolate =  (page , size) => {
    return axios.get(`${BASE_URL_PROTUCT}/get_by_category/chocolate/?page=${page}&size=${size}`);
    
} 
export const getAllCake =  (page , size) => {
    return axios.get(`${BASE_URL_PROTUCT}/get_by_category/cake/?page=${page}&size=${size}`);
    
}
export const getAllCookie =  (page , size) => {
    return axios.get(`${BASE_URL_PROTUCT}/get_by_category/cookie/?page=${page}&size=${size}`);
    
}
// Chocolate boxes are catalog items in the category chocolate-box-<size>
// (the size is how many chocolates the box holds).
export const getChocolateBoxes = () => {
    return axios.get(`${BASE_URL_PROTUCT}/boxes`);
}
export const getItemById =async (id) => {
    const {data} = await axios.get(`${BASE_URL_PROTUCT}/get-by-id/${id}`);
    return data;
}
export const getItemByName = async (name) => {
    
    const {data} = await axios.get(`${BASE_URL_PROTUCT}/${name}`);
    
    return data;
}
export const createItem = (formData) => {
  const result =  axios.post(`${BASE_URL}/admin/item`,formData,  {
  headers: {
      ...getAuthHeader(),
    }
});
return result;
}

// Multipart now, mirroring createItem above - a new photo is optional (see
// AdminProducts.jsx's updateItemId, which only appends a 'file' part when
// one was actually picked). No explicit Content-Type - axios sets the
// multipart boundary itself from the FormData instance.
export const updateItem = (formData) => {
    return axios.put(`${BASE_URL}/admin/update_item`, formData, { headers: getAuthHeader() });
}

export const deleteItemById = (id) => {
    return axios.delete(`${BASE_URL}/admin/delete_by_id/${id}`, { headers: getAuthHeader() });
}
export const deleteItemByName = (name) => {
    return axios.delete(`${BASE_URL}/admin/delete_by_name/${name}`, { headers: getAuthHeader() });
}
// favorite
export const addItemToFavorite =async (id) => {
    return await axios.post(`${BASE_URL}/favorite/item/${id}`,null,{ headers: getAuthHeader() });
}

export const removeItemFromFavorite = (id) => {
    return axios.delete(`${BASE_URL}/favorite/item/${id}`,  { headers: getAuthHeader() });
}

export const getAllFavoriteItems = () => {
    return axios.get(`${BASE_URL}/favorite/item`, { headers: getAuthHeader() });
}
// order
export const addItemToOrder =  (id) => {
    return axios.post(`${BASE_URL}/order/${id}`, null, { headers: getAuthHeader() });
}
// chocolates: [{ id, quantity }] - which chocolates fill the box and in how
// many squares. The server recomputes price and checks the box is full.
export const addBoxToOrder = (boxItemId, chocolates) => {
    return axios.post(`${BASE_URL}/order/box`, { box_item_id: boxItemId, chocolates }, { headers: getAuthHeader() });
}
export const updateBoxInOrder = (orderItemId, chocolates) => {
    return axios.put(`${BASE_URL}/order/box/${orderItemId}`, { chocolates }, { headers: getAuthHeader() });
}
export const removeBoxFromOrder = (orderItemId) => {
    return axios.delete(`${BASE_URL}/order/box/${orderItemId}`, { headers: getAuthHeader() });
}
export const getAllOrderByEmail = (email) => {
    return axios.get(`${BASE_URL}/admin/order/${email}`, { headers: getAuthHeader() });
}
export const getAllOrders = () => {
    return axios.get(`${BASE_URL}/order`,{ headers: getAuthHeader() });
}
export const removeItemFromOrder = (id) => { 
    return axios.delete(`${BASE_URL}/order/item/${id}`, { headers: getAuthHeader() });
}
export const updateOrder = (note) => {
    return axios.put(`${BASE_URL}/order`, { note }, { headers: getAuthHeader() });
}
export const deleteOrderById = (id) => {
    return axios.delete(`${BASE_URL}/order/${id}` ,  { headers: getAuthHeader() })
}
// Keren's admin order board - RECEIVED/IN_PROGRESS/READY orders, grouped by
// status client-side (see AdminOrders.jsx).
export const getAdminOrdersBoard = () => {
    return axios.get(`${BASE_URL}/admin/orders/board`, { headers: getAuthHeader() });
}
export const advanceOrderStatus = (orderId, status, readyBy) => {
    const readyByParam = readyBy ? `&readyBy=${readyBy}` : '';
    return axios.put(`${BASE_URL}/admin/order/${orderId}/status?status=${status}${readyByParam}`, null, { headers: getAuthHeader() });
}
// Admin search-by-order-number - finds any order by id regardless of status
// (including CANCELLED, or one further back than the board's own pagination
// shows), unlike getAdminOrdersBoard above.
export const getOrderByIdForAdmin = (orderId) => {
    return axios.get(`${BASE_URL}/admin/order/by-id/${orderId}`, { headers: getAuthHeader() });
}
